export enum QrScanView {
    QRSCAN = 0,
    ARRIVED = 1,
    QRNOTRECOGNIZED = 2,
    TRANSFERTOARRIVE = 3,
  }
  